import { initializeApp } from 'firebase/app';
import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth'; // Import auth functions
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getFunctions } from 'firebase/functions';


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBDh6eYQNC26ye3uxQ5gl8QP-LC36Lc9hw", // Replace with your actual API key
  authDomain: "churchaware-8f158.firebaseapp.com",
  projectId: "churchaware-8f158",
  storageBucket: "churchaware-8f158.appspot.com",
  messagingSenderId: "431242702917",
  appId: "1:431242702917:web:b901f3d11c0c5d4d83332c", // Replace with your actual App ID
  measurementId: "G-K1MGZCBWV3",
  databaseURL: "https://churchaware-8f158.firebaseio.com" // Add databaseURL if you use Realtime Database
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app); // Export the auth instance
const db = getFirestore(app); // Export db
const functions = getFunctions(app); // Initialize Functions HERE
const storage = getStorage(app);
export { signInWithEmailAndPassword, signOut }; // Export auth functions
const analytics = getAnalytics(app);

try {
  const appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider('6LfKASUrAAAAAEoL18pxGiltyG7yhwf3fc8gK_7q'),
    isTokenAutoRefreshEnabled: true
  });
  console.log("Firebase App Check initialized.");

} catch (err) {
    console.error("Error initializing Firebase App Check:", err);
}

export { app, auth, db, storage, functions };
